import * as React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import cx from 'classnames';

import './ActionsButton.styles.scss';

export const TRIGGER_TYPE = {
    hover: 'hover',
    click: 'click',
};

const MENU_ITEM_HORIZONTAL_PADDING = 8;

export default class ActionsButton extends React.Component {
    static defaultProps = {
        setCurrent: () => {},
        menuItems: [],
        triggerType: TRIGGER_TYPE.click,
        withStopPropagation: true,
        withBackdrop: true,
    }

    ref = React.createRef();
    state = {
        isOpen: false,
    };

    get menuItems() {
        const { menuItems, id, data } = this.props;

        return menuItems.map(({ onClick = () => {}, label }, i) => ({
            label,
            value: label,
            onClick: () => {
                this.close();
                onClick(id, data);
            },
        }));
    }

    open = (e) => {
        e.persist();

        const { withStopPropagation, id, data, onOpen } = this.props;

        if (withStopPropagation) {
            e.stopPropagation();
        }

        this.setState(
            (state) => ({
                ...state,
                isOpen: !state.isOpen
            }),
            () => {
                if (this.state.isOpen) {
                    const { setCurrent, id } = this.props;

                    setCurrent(id);
                }
            }
        );

        if (onOpen) {
            onOpen(id, data);
        }
    }

    close = () => {
        this.setState((state) => ({
            ...state,
            isOpen: false
        }));
    }

    get menuWidth() {
        const { menuItems } = this.props;

        const longestWord = menuItems
            .map(({ label }) => label)
            .reduce((acc, currentTitle) => acc.length < currentTitle.length ? currentTitle : acc, '');
        const pxPerChar = 7.5;

        return longestWord.length * pxPerChar + MENU_ITEM_HORIZONTAL_PADDING * 2;
    }

    getStyles = (baseStyles) => {
        return {
            ...baseStyles, 
            zIndex: 9999999,
            width: this.menuWidth 
        };
    }

    handleSelect = ({ onClick }) => {
        onClick();
    }

    renderTriggerBtn = () => {
        const { variant = 'lines', classes = {}, id, trigger } = this.props;
        const elementId = 'dropdown-basic-' + id;

        if (trigger) {
            return (
                <span 
                    id={elementId}
                    role="button"
                >
                    {trigger}
                </span>
            );
        }

        const variantView = {
            lines: (
                <button
                    id={elementId}
                    className={cx('ActionsButton__button ActionsButton__button-lines', classes.triggerBtn)}
                    onClick={this.open}
                >
                    <i className="fa fa-bars" />
                    <i className="fa fa-caret-down" />
                </button>
            ),
            'arrow-down': (
                <button 
                    id={elementId}
                    className={cx('ActionsButton__button ActionsButton__button-arrow-down', classes.triggerBtn)}
                    onClick={this.open}
                >
                    <span className="fa fa-angle-down ActionsButton__button-arrow-down-icon" />
                </button>
            )
        };  

        return variantView[variant];
    }

    get customMenuPositioning() {
        const { current } = this.ref;

        if (current) {
            const { top, left, width } = current.getBoundingClientRect();

            return {
                top,
                left: left + width,
            };
        }

        return {};
    }

    get customMenu() {
        if (!this.state.isOpen) {
            return null;
        }

        const { children } = this.props;

        return (
            <div
                className="ActionsButton__custom-menu-container"
                style={{
                    ...this.customMenuPositioning
                }}
            >
                {children}
            </div>
        );
    }

    handleBackdropClick = (e) => {
        e.stopPropagation();
        this.close();
    }

    stopPropagation = (e) => {
        e.stopPropagation();
    }

    render() {
        const { isOpen } = this.state;
        const { withBackdrop, triggerType, children, className } = this.props;
        const shouldTriggerOnHover = triggerType === TRIGGER_TYPE.hover;

        return (
            <span 
                ref={this.ref}
                className={cx('ActionsButton', className)} 
                onMouseEnter={shouldTriggerOnHover ? this.open : undefined} 
                onMouseLeave={shouldTriggerOnHover ? this.close : undefined}
                onClick={this.stopPropagation}
            >
                {this.renderTriggerBtn()}
                {withBackdrop && isOpen && (
                    <div className="ActionsButton__backdrop" onClick={this.handleBackdropClick} />
                )}
                {children 
                    ? this.customMenu
                    : (
                        <Select
                            closeMenuOnSelect
                            styles={{
                                menuPortal: this.getStyles
                            }}
                            menuIsOpen={isOpen}
                            menuPortalTarget={document.body}
                            isSearchable={false}
                            value={null}
                            options={this.menuItems}
                            menuPosition="fixed"
                            className="ActionsButton__menu-container"
                            classNamePrefix="ActionsButton__menu"
                            menuShouldScrollIntoView={false}
                            menuPlacement="bottom"
                            onChange={this.handleSelect}
                        />
                    )
                }
            </span>
        );
    }
}

ActionsButton.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]).isRequired,
            onClick: PropTypes.func,
        })
    ),
    setCurrent: PropTypes.func.isRequired,
};